import { useSuspenseQuery } from '@tanstack/react-query';

import { cacheKeys } from '../config';
import { disciplineClient } from '../client/disciplineClient';

type Options = {
};

const defaultOptions: Partial<Options> = {
};

export const useDisciplines = (params: Disciplines.GetListParams = {}, options: Partial<Options> = defaultOptions) => {
  const { data: { data } = {}, ...rest } = useSuspenseQuery({
    queryKey: [cacheKeys.getDisciplines, params],
    queryFn: () => disciplineClient.getDisciplines(params),
  });

  return {
    ...rest,
    count: data?.count || 0,
    disciplines: data?.results || [],
  };
};
